module.exports = __webpack_public_path__ + "img/about-辅导项目-中级职称（临床）类.ef0b2464.jpg";